/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PartnerBaseDto as OkEgisServiceModelsDtoPartnerBaseDto } from '../models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { PartnerDto as OkEgisServiceModelsDtoPartnerDto } from '../models/OK/Egis/Service/Models/DTO/partner-dto';
import { PartnerWithCustomerCountDto as OkEgisServiceModelsDtoPartnerWithCustomerCountDto } from '../models/OK/Egis/Service/Models/DTO/partner-with-customer-count-dto';
import { CreatePartnerRequest as OkEgisServiceModelsRequestCreatePartnerRequest } from '../models/OK/Egis/Service/Models/Request/create-partner-request';
import { UpdatePartnerRequest as OkEgisServiceModelsRequestUpdatePartnerRequest } from '../models/OK/Egis/Service/Models/Request/update-partner-request';
import { GetServiceaftalePartnerChangeResponse as OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse } from '../models/OK/Egis/Service/Models/Response/get-serviceaftale-partner-change-response';

@Injectable({
  providedIn: 'root',
})
export class PartnerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllPartnere
   */
  static readonly GetAllPartnerePath = '/api/v1/Partner/GetAllPartnere';

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPartnere()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnere$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.GetAllPartnerePath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>;
      })
    );
  }

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllPartnere$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnere(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerBaseDto>> {

    return this.getAllPartnere$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerBaseDto>)
    );
  }

  /**
   * Path part for operation getAllPartnereWithCustomerCount
   */
  static readonly GetAllPartnereWithCustomerCountPath = '/api/v1/Partner/GetAllPartnereWithCustomerCount';

  /**
   * Returns a list of Partners with customer count data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPartnereWithCustomerCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnereWithCustomerCount$Response(params: {
    includeInactive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.GetAllPartnereWithCustomerCountPath, 'get');
    if (params) {
      rb.query('includeInactive', params.includeInactive, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>>;
      })
    );
  }

  /**
   * Returns a list of Partners with customer count data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllPartnereWithCustomerCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPartnereWithCustomerCount(params: {
    includeInactive?: boolean;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>> {

    return this.getAllPartnereWithCustomerCount$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>)
    );
  }

  /**
   * Path part for operation getActivePartnere
   */
  static readonly GetActivePartnerePath = '/api/v1/Partner/GetActivePartnere';

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActivePartnere()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivePartnere$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.GetActivePartnerePath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>;
      })
    );
  }

  /**
   * Returns a list of Partners.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getActivePartnere$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActivePartnere(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerBaseDto>> {

    return this.getActivePartnere$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerBaseDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerBaseDto>)
    );
  }

  /**
   * Path part for operation getPartner
   */
  static readonly GetPartnerPath = '/api/v1/Partner/{partnerNo}';

  /**
   * Returns partner information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartner$Response(params: {

    /**
     * Partner No
     */
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.GetPartnerPath, 'get');
    if (params) {
      rb.path('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>;
      })
    );
  }

  /**
   * Returns partner information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartner(params: {

    /**
     * Partner No
     */
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerDto> {

    return this.getPartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>) => r.body as OkEgisServiceModelsDtoPartnerDto)
    );
  }

  /**
   * Path part for operation getPartnerWithCustomerCount
   */
  static readonly GetPartnerWithCustomerCountPath = '/api/v1/Partner/GetPartnerWithCustomerCount';

  /**
   * Returns partner information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerWithCustomerCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerWithCustomerCount$Response(params: {

    /**
     * Partner No
     */
    partnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.GetPartnerWithCustomerCountPath, 'get');
    if (params) {
      rb.query('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>;
      })
    );
  }

  /**
   * Returns partner information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerWithCustomerCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerWithCustomerCount(params: {

    /**
     * Partner No
     */
    partnerNo?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerWithCustomerCountDto> {

    return this.getPartnerWithCustomerCount$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerWithCustomerCountDto>) => r.body as OkEgisServiceModelsDtoPartnerWithCustomerCountDto)
    );
  }

  /**
   * Path part for operation createPartner
   */
  static readonly CreatePartnerPath = '/api/v1/Partner';

  /**
   * Create partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartner$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Update partner request
     */
    body?: OkEgisServiceModelsRequestCreatePartnerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.CreatePartnerPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>;
      })
    );
  }

  /**
   * Create partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPartner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartner(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Update partner request
     */
    body?: OkEgisServiceModelsRequestCreatePartnerRequest
  }): Observable<OkEgisServiceModelsDtoPartnerDto> {

    return this.createPartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>) => r.body as OkEgisServiceModelsDtoPartnerDto)
    );
  }

  /**
   * Path part for operation updatePartner
   */
  static readonly UpdatePartnerPath = '/api/v1/Partner/{id}';

  /**
   * Update partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartner$Response(params: {

    /**
     * Partner id
     */
    id: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Update partner request
     */
    body?: OkEgisServiceModelsRequestUpdatePartnerRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.UpdatePartnerPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>;
      })
    );
  }

  /**
   * Update partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePartner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartner(params: {

    /**
     * Partner id
     */
    id: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;

    /**
     * Update partner request
     */
    body?: OkEgisServiceModelsRequestUpdatePartnerRequest
  }): Observable<OkEgisServiceModelsDtoPartnerDto> {

    return this.updatePartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerDto>) => r.body as OkEgisServiceModelsDtoPartnerDto)
    );
  }

  /**
   * Path part for operation activeServiceaftaler
   */
  static readonly ActiveServiceaftalerPath = '/api/v1/Partner/ActiveServiceaftaler /{partnerNo}';

  /**
   * Get list of active serviceaftaler for a partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activeServiceaftaler()` instead.
   *
   * This method doesn't expect any request body.
   */
  activeServiceaftaler$Response(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.ActiveServiceaftalerPath, 'get');
    if (params) {
      rb.path('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>;
      })
    );
  }

  /**
   * Get list of active serviceaftaler for a partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `activeServiceaftaler$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  activeServiceaftaler(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse> {

    return this.activeServiceaftaler$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse)
    );
  }

  /**
   * Path part for operation serviceaftalerSwitchingToOtherPartner
   */
  static readonly ServiceaftalerSwitchingToOtherPartnerPath = '/api/v1/Partner/ServiceaftalerSwitchingToOtherPartner/{partnerNo}';

  /**
   * Get list of serviceaftaler switching to other partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceaftalerSwitchingToOtherPartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerSwitchingToOtherPartner$Response(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.ServiceaftalerSwitchingToOtherPartnerPath, 'get');
    if (params) {
      rb.path('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>;
      })
    );
  }

  /**
   * Get list of serviceaftaler switching to other partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `serviceaftalerSwitchingToOtherPartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerSwitchingToOtherPartner(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse> {

    return this.serviceaftalerSwitchingToOtherPartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse)
    );
  }

  /**
   * Path part for operation serviceaftalerSwitchingToPartner
   */
  static readonly ServiceaftalerSwitchingToPartnerPath = '/api/v1/Partner/ServiceaftalerSwitchingToPartner/{partnerNo}';

  /**
   * Get list of serviceaftaler switching to partner.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceaftalerSwitchingToPartner()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerSwitchingToPartner$Response(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.ServiceaftalerSwitchingToPartnerPath, 'get');
    if (params) {
      rb.path('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>;
      })
    );
  }

  /**
   * Get list of serviceaftaler switching to partner.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `serviceaftalerSwitchingToPartner$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerSwitchingToPartner(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse> {

    return this.serviceaftalerSwitchingToPartner$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse)
    );
  }

  /**
   * Path part for operation serviceaftalerNotChanged
   */
  static readonly ServiceaftalerNotChangedPath = '/api/v1/Partner/ServiceaftalerNotChanged/{partnerNo}';

  /**
   * Get list of serviceaftaler not changed.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceaftalerNotChanged()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerNotChanged$Response(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.ServiceaftalerNotChangedPath, 'get');
    if (params) {
      rb.path('partnerNo', params.partnerNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>;
      })
    );
  }

  /**
   * Get list of serviceaftaler not changed.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `serviceaftalerNotChanged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceaftalerNotChanged(params: {
    partnerNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse> {

    return this.serviceaftalerNotChanged$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse>) => r.body as OkEgisServiceModelsResponseGetServiceaftalePartnerChangeResponse)
    );
  }

  /**
   * Path part for operation startMonthlyNotification
   */
  static readonly StartMonthlyNotificationPath = '/api/v1/Partner/StartMonthlyNotification';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startMonthlyNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  startMonthlyNotification$Response(params: {
    startDate?: string;
    endDate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, PartnerService.StartMonthlyNotificationPath, 'get');
    if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('endDate', params.endDate, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startMonthlyNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  startMonthlyNotification(params: {
    startDate?: string;
    endDate?: string;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<string> {

    return this.startMonthlyNotification$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
